import {Auditable} from "./auditable.model";

export class Customer extends Auditable {
  customerId: number;
  businessName: string;
  legalName: string;
  primaryContact: string;
  primaryContactName: string;

  constructor(customer?: Customer) {
    super(customer);
  }
}
